import React from 'react';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import StatsSection from './StatsSection';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <ServicesSection />
      <StatsSection />
    </div>
  );
};

export default HomePage;